import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form, Button } from "react-bootstrap";
import "./reset-password.scss";
import { ResetPasswordByPcAdmin } from "../../../api";
import Loader from "../../loader/loader";

import * as yup from "yup";
const schema = yup.object({
    password: yup
        .string()
        .trim()
        .required("* Password Is Required")
        .min(8, "The confirm password must be at least 8 characters."),
    password_confirmation: yup
        .string()
        .trim()
        .required("* Confirm Password Is Required")
        .min(8, "The password must be at least 8 characters.")
        .oneOf(
            [yup.ref("password"), null],
            "The Password confirmation does not match.",
        ),
});
class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            formData: {
                password: "",
                password_confirmation: "",
            },
            errors: [],
        };
    }
    componentDidMount() {}
    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    handleChangePassword(evt) {
        this.setState({ show_spinner: true });

        const fromData = this.state.formData;

        const postData = {
            id: this.props.menberId,
            password: fromData.password,
            password_confirmation: fromData.password_confirmation,
        };
        ResetPasswordByPcAdmin(postData).then((res) => {
            if (res.status === 200) {
                this.setState({ show_spinner: false });
                this.setState({
                    show_login_link: true,
                    errorMessage: "Password Reset Successfully.",
                });
                this.props.menberIdSetNull();
                setTimeout(() => {
                    this.props.handleCloseModel();
                }, 3500);
            } else {
                this.setState({ show_spinner: false });
                res.message
                    ? this.setState({ errorMessage: res.message })
                    : this.setState({
                          errorMessage:
                              "Sorry! something wrong please try again...",
                      });
            }
        });
    }

    render() {
        const { show_spinner, errorMessage, formData, errors, is_submitted } =
            this.state;
        return (
            <ReactModal
                isOpen={this.props.showResetPasswordModel}
                className="add-template-modal heighAuto"
            >
                <div className="modal-header">
                    <h4 className="text-left">Reset Password</h4>
                </div>
                <div
                    onClick={() => this.props.handleCloseModel()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleChangePassword(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="rest-password"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <label className="modal-lab">
                                            Password
                                        </label>
                                        <Form.Control
                                            placeholder="Password"
                                            type="password"
                                            name="password"
                                            value={
                                                values.password
                                                    ? values.password
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.password &&
                                                !!errors.password
                                            }
                                            isValid={
                                                is_submitted && !errors.password
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.password}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <label className="modal-lab">
                                            Confirm Password
                                        </label>
                                        <Form.Control
                                            placeholder="Confirm Password"
                                            type="password"
                                            name="password_confirmation"
                                            value={
                                                values.password_confirmation
                                                    ? values.password_confirmation
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.password_confirmation &&
                                                !!errors.password_confirmation
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.password_confirmation
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.password_confirmation}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message">{errorMessage}</p>
                <div className="modal-footer">
                    <div className="button-twoc">
                        <button
                            form="rest-password"
                            type="submit"
                            className="btn confirm-button"
                        >
                            {" "}
                            Update{" "}
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default ResetPassword;
